<template>
  <div class="layout">
    <!-- 左侧菜单 -->
    <Menu @menuEvent="handleMenuSearch"/>

    <div class="right-container">
      <!-- 🔥 全局 Header，自动读取路由里的标题 + 是否显示搜索 -->
      <Header
          :pageTitle="$route.meta.title"
          :show-search-icon="$route.meta.showSearchIcon"
          @searchList="handleSearch"
      />

      <!-- 页面内容区 -->
      <div class="page-content">
        <router-view ref="pageView"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Menu from '@/components/Menu'
  import Header from '@/components/Header'

  export default {
    name: 'Layout',
    components: {Menu, Header},
    methods: {
      // 菜单筛选 → 传给页面
      handleMenuSearch(data) {
        if (this.$refs.pageView && this.$refs.pageView.handleMenuSearch) {
          this.$refs.pageView.handleMenuSearch(data)
        }
      },
      // 搜索 → 传给页面
      handleSearch(val) {
        if (this.$refs.pageView && this.$refs.pageView.handleSearch) {
          this.$refs.pageView.handleSearch(val)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  // 关键修复：html/body 全局高度100%，layout强制占满视口
  :deep(html, body) {
    margin: 0;
    padding: 0;
    height: 100%;
    background: #f5f7ff;
  }

  .layout {
    display: flex;
    width: 100%;
    height: 100vh; /* 必须加：强制占满屏幕高度，底部无空白 */
    overflow: hidden;
    background: #f5f7ff;
  }

  .right-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 24px 32px;
    background: #f5f7ff; /* 兜底背景色，和全局一致 */
  }

  .page-content {
    flex: 1;
    overflow-y: auto;
    background: #f5f7ff; /* 内容区铺满背景 */
  }
</style>
